<template>

  <skeleton-loading>
    <div class='border-card  mb-3 '>
      <skeleton-square
        :box-properties="{
            height: '300px',
          }"
        :count='1'
      ></skeleton-square>

      <div class="px-2 pb-3">
        <div style="margin-bottom:20px">
          <skeleton-square
            :box-properties="{
            height: '16px',
            top:'10px'
          }"
            :count='1'
          ></skeleton-square>
        </div>

        <div class='d-flex mt-2 skeleton-container'>
          <div >
            <skeleton-square
              :box-properties="{
            height: '16px',
            width: '70px',

          }"
              :count='1'
            ></skeleton-square>
          </div>
          <div>
            <skeleton-square
              :box-properties="{
            height: '16px',
            width: '70px',
          }"
              :count='1'
            ></skeleton-square>
          </div>

        </div>
      </div>


    </div>
  </skeleton-loading>
</template>

<script>
import SkeletonLoading from '../../../components/Skeleton/SkeletonLoading';
import SkeletonSquare from '../../../components/Skeleton/components/SkeletonSquare';

export default {
  name: 'SkeletonAdminProduct',
  components: {
    SkeletonLoading,
    SkeletonSquare,
  },
};
</script>

<style scoped>
.border-card {
  border: 1px solid #f1f1f1;
  border-radius: 3px;
}
.skeleton-container{
  justify-content: space-between;
}
</style>
